/**
 * The 8 x 8 font, letters (docs/spec/04 §1): our own glyphs (shared with STONEFALL), two-pixel vertical
 * strokes, seven rows tall with the eighth left for spacing. Rows are separated by `|`.
 */
export const LETTERS: Readonly<Record<string, string>> = {
  A: '..####..|.##..##.|.##..##.|.######.|.##..##.|.##..##.|.##..##.|........',
  B: '.#####..|.##..##.|.##..##.|.#####..|.##..##.|.##..##.|.#####..|........',
  C: '..####..|.##..##.|.##.....|.##.....|.##.....|.##..##.|..####..|........',
  D: '.####...|.##.##..|.##..##.|.##..##.|.##..##.|.##.##..|.####...|........',
  E: '.######.|.##.....|.##.....|.#####..|.##.....|.##.....|.######.|........',
  F: '.######.|.##.....|.##.....|.#####..|.##.....|.##.....|.##.....|........',
  G: '..####..|.##..##.|.##.....|.##.###.|.##..##.|.##..##.|..#####.|........',
  H: '.##..##.|.##..##.|.##..##.|.######.|.##..##.|.##..##.|.##..##.|........',
  I: '..####..|...##...|...##...|...##...|...##...|...##...|..####..|........',
  J: '...####.|....##..|....##..|....##..|.##.##..|.##.##..|..###...|........',
  K: '.##..##.|.##.##..|.####...|.###....|.####...|.##.##..|.##..##.|........',
  L: '.##.....|.##.....|.##.....|.##.....|.##.....|.##.....|.######.|........',
  M: '.##...##|.###.###|.#######|.##.#.##|.##...##|.##...##|.##...##|........',
  N: '.##..##.|.###.##.|.######.|.######.|.##.###.|.##..##.|.##..##.|........',
  O: '..####..|.##..##.|.##..##.|.##..##.|.##..##.|.##..##.|..####..|........',
  P: '.#####..|.##..##.|.##..##.|.#####..|.##.....|.##.....|.##.....|........',
  Q: '..####..|.##..##.|.##..##.|.##..##.|.##..##.|..####..|....###.|........',
  R: '.#####..|.##..##.|.##..##.|.#####..|.####...|.##.##..|.##..##.|........',
  S: '..####..|.##..##.|.##.....|..####..|.....##.|.##..##.|..####..|........',
  T: '.######.|...##...|...##...|...##...|...##...|...##...|...##...|........',
  U: '.##..##.|.##..##.|.##..##.|.##..##.|.##..##.|.##..##.|..####..|........',
  V: '.##..##.|.##..##.|.##..##.|.##..##.|.##..##.|..####..|...##...|........',
  W: '.##...##|.##...##|.##...##|.##.#.##|.#######|.###.###|.##...##|........',
  X: '.##..##.|.##..##.|..####..|...##...|..####..|.##..##.|.##..##.|........',
  Y: '.##..##.|.##..##.|.##..##.|..####..|...##...|...##...|...##...|........',
  Z: '.######.|.....##.|....##..|...##...|..##....|.##.....|.######.|........',
};
